import { Directive, HostBinding } from '@angular/core';
import { StateSrefBase } from './state-sref.base';

@Directive({
    selector: 'a[fiStateSref]',
    exportAs: 'fiStateSref',
    standalone: false,
})
export class StateSrefLinkDirective extends StateSrefBase {
    @HostBinding('href')
    get href() {
        return this.getUrl();
    }

    onClick($event: MouseEvent) {
        super.onClick($event);
        $event.preventDefault();
    }
}
